module.exports = __webpack_public_path__ + "static/img/produto_g.7d84207.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/produtos/laranja/produto_g.png
// module id = FtBn
// module chunks = 0